import { render, staticRenderFns } from "./peakvalley.vue?vue&type=template&id=8bbfe24c&scoped=true&"
import script from "./peakvalley.vue?vue&type=script&lang=js&"
export * from "./peakvalley.vue?vue&type=script&lang=js&"
import style0 from "./peakvalley.vue?vue&type=style&index=0&id=8bbfe24c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbfe24c",
  null
  
)

export default component.exports